import React, { useState, useEffect, useContext, useMemo } from "react";
import _ from "lodash";
import axios from "axios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import styled from "styled-components";
import UserService from "services/UserService";
import { getAccountMeters } from "services/ConfigServices";
import EditButton from "components/CustomButtons/EditButton";
import { energyType } from "variables/lists/action";
import { targetedenergyList } from "variables/lists/action";
//import useActionTable from "../useActionTable.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable(selectedMeters) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const [totalRows, setTotalRows] = useState(0);
  const [results, setResults] = useState();
  const [isRefetched, setIsRefetched] = useState(false);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const appContext = useContext(ActionPlansContext);
  const { actionPlans } = appContext;
  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  useEffect(() => {
    getStructureData();
  }, [isRefetched]);

  const getStructureData = async () => {
    let data = [];
    let meters = action.parameters?.impact?.meters || [];

    let metersIds = [];
    if (meters !== undefined || meters.length == 0) {
      metersIds = meters.map((meter) => {
        return meter.uuid;
      });
    }

    let newData = await getAccountMetersData("electricity");
    data.push(newData);

    data = data.flat();
    meters == undefined || meters.length == 0
      ? setStructureData(data)
      : setStructureData([
          ...data.filter((obj) => !metersIds.includes(obj.uuid)),
          ...meters,
        ]);
  };

  const getAccountMetersData = async (energy) => {
    let data = [];
    await axios
      .get(getAccountMeters(action.parameters.general.groups[0], energy), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        data = res.data.meters;
      });
    data.map((x) => (x.details.energy = energy));
    return data;
  };

  const filteredItems = useMemo(
    () =>
      structureData?.filter((item) =>
        item?.meternumber.toLowerCase().includes(filterText.toLowerCase())
      ),
    [filterText]
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    return (
      <>
        <TableName></TableName>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
      </>
    );
  }, [filterText, resetPaginationToggle]);

  const contextActions = useMemo(() => {
    const handleDelete = () => {

    };
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        <button
          key="delete"
          onClick={handleDelete}
          style={{ backgroundColor: "#91C73C" }}
          icon
        >
          OPTIMISER
        </button>
      </>
    );
  }, [filteredItems, selectedMeters]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filterText !== "" ? filteredItems : structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      title: "",
      contextActions: contextActions,
      subHeaderComponent: subHeaderComponentMemo,
    },
    refreshTable,
  };
}
